
import React, { Component}  from 'react';
import {NavLink} from 'react-router-dom';
import Layout  from 'components/Dashboard/Layout';

import { StyledMenu } from './Styled';
import EditIcon from "@material-ui/icons/Edit";


export default class ClientDetailHeader extends Component {

  getMenuItems = (item) => {
    const { history } = this.props;
    let items = [
      {url: `/client/${item.id}`, label: 'Информация', active: false},
      {url: `/client/${item.id}/orders`, label: 'Грузоперевозки', active: false},
      {url: `/client/${item.id}/contracts`, label: 'Договоры', active: false},
      {url: `/client/${item.id}/changes`, label: 'Изменения', active: false},
      {url: `/client/${item.id}/edit`, icon: EditIcon, active: false},
    ];

    items.forEach(item => {
      if (item.url === history.location.pathname) {
        item.active = true;
      }
    })

    return items;
  }

  render() {
    const { item } = this.props;
    return (
      <>
        <Layout.Header
          title={item.name}
          backUrl={'/client'}
        />

        <StyledMenu>
          {this.getMenuItems(item).map(item =>
            <li className={item.active ? 'active' : undefined} key={item.url}>
              <NavLink to={item.url}>
                {item.icon && <item.icon size="small" />}
                {item.label && item.label}
              </NavLink>
            </li>
          )}
        </StyledMenu>
      </>
    )
  }
}
